<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem>参会人管理</BreadcrumbItem>
      <BreadcrumbItem>参会人列表</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <div style="text-align: right; width: 400px; margin: 0 auto 20px">
        <Input v-model.trim="searchMobile" @on-enter="search(1)" size="large" placeholder="输入手机号搜索">
        <Button slot="append" type="primary" icon="ios-search" @click="search(1)">搜索</Button>
        </Input>
      </div>
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          参会人列表
          <Input >
          <Button slot="append" icon="ios-search"></Button>
          </Input>
        </p>
        <Table :columns="columns" :data="rows" :show-header="true"></Table>
        <Page :total="totalCount" :page-size="pageSize" :current.sync="currentPage" show-total show-elevator @on-change="handlePageChange" style="margin-top: 10px; text-align: right" />
      </Card>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'
import ExpandRow from './ExpandRow'
import { mapState } from 'vuex'

export default {
  name: 'AttendeeList',
  data () {
    return {
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      remoteStatus: null,
      attendeeList: [],
      tableLoading: true,
      searchMobile: '',
      columns: [
        {
          title: '手机号',
          key: 'mobile'
        },
        {
          title: '姓名',
          key: 'name'
        },
        {
          title: '公司',
          key: 'companyName'
        },
        {
          title: '邮箱',
          key: 'email'
        },
        {
          title: '报名次数',
          key: 'attendCount'
        },
        {
          type: 'expand',
          title: '手机号参会记录',
          width: 150,
          render: (h, params) => {
            return h(ExpandRow, {
              props: {
                mobile: params.row.mobile
              }
            })
          }
        }
      ]
    }
  },
  computed: {
    ...mapState({
      loginUser: 'user'
    }),
    rows () {
      return this.attendeeList
    }
  },
  methods: {
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
    },
    handlePageChange () {
      this.search(this.currentPage)
    },
    async search (startPage) {
      try {
        this.$Loading.start()
        let queryStr = `?page=${startPage}&size=${this.pageSize}`

        if (this.searchMobile) {
          queryStr += `&mobile=${this.searchMobile}`
        }

        let resp = await this.$http.get(`/api/admin/meetings/mine/attendees${queryStr}`)
        this.totalCount = resp.body.totalElements
        this.totalPage = resp.body.totalPages
        this.attendeeList = resp.body.content
        this.$Loading.finish()
      } catch (e) {
        console.log(e)
        this.afterSave(e)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get('/api/admin/meetings/mine/attendees?page=1&size=20')
      next(vm => {
        vm.remoteStatus = resp.status
        vm.totalCount = resp.body.totalElements
        vm.totalPage = resp.body.totalPages
        vm.attendeeList = resp.body.content
        vm.searchMobile = null
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.attendeeList = []
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/meetings/mine/attendees?page=1&size=${this.pageSize}`)
      this.remoteStatus = resp.status
      this.totalCount = resp.body.totalElements
      this.totalPage = resp.body.totalPages
      this.attendeeList = resp.body.content
      this.searchMobile = null
      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.attendeeList = []
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/attendee/AttendeeList.vue